import { TableCell, TableHead, TableRow } from 'component-library';
import { ReactNode } from 'react';

export const StaffPortalTableHeadCell = ({ children }: { children?: ReactNode }) => (
  <TableHead className='typography-overline h-12 px-6 py-4 text-left align-middle leading-4 text-text-secondary'>
    {children}
  </TableHead>
);

export const StaffPortalTableCell = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <TableCell className={`typography-body1 p-6 align-middle ${className}`.trim()}>{children}</TableCell>
);

export const StaffPortalTableEmptyRow = ({ colSpan, message }: { colSpan: number; message: string }) => (
  <TableRow>
    <TableCell colSpan={colSpan} className='typography-body1 p-6 text-center text-text-secondary'>
      {message}
    </TableCell>
  </TableRow>
);
